import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'

const PathB = styled.path`
  stroke: ${prop('color')};
  fill: none;
  stroke-linecap: round;
  stroke-width: 3px;
`

function NewPinCancelActionButtons({
  onClick,
  color = colorsOptions.secondaryColors.green.normal,
}) {
  return (
    <svg onClick={onClick} width={56} height={56}>
      <defs />
      <path
        d="M28 44a16 16 0 1 0-16-16 16 16 0 0 0 16 16"
        stroke={color}
        fill="#fff"
        strokeWidth={1.5}
      />
      <PathB color={color} d="M22 34l12-12M34 34L22 22" />
      <path fill="none" d="M0 0h56v56H0z" />
    </svg>
  )
}

NewPinCancelActionButtons.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
}

function NewPinCreateActionButtons({
  onClick,
  color = colorsOptions.secondaryColors.green.normal,
}) {
  return (
    <svg onClick={onClick} width={56} height={56}>
      <path
        d="M28 44a16 16 0 1 0-16-16 16 16 0 0 0 16 16"
        fill={color}
        stroke={color}
        strokeWidth={1.5}
      />
      <path
        d="M19.837 28.625l5.03 5.025 11.3-11.3"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        fill="none"
      />
      <path fill="none" d="M0 0h56v56H0z" />
    </svg>
  )
}

NewPinCreateActionButtons.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
}

export { NewPinCancelActionButtons, NewPinCreateActionButtons }

/**
 * New Pin Create and Cancel action buttons
 * @component
 */
export default {}
